import styled from "styled-components";

export const CardStyle = styled.div`
    width: 100%;
  
  

`